import { RouteConfig } from 'vue-router';

import RouterView from '@/components/layout/Router.vue';
import { teamExamsConductRoute } from './exam/examConduct/examsConduct.route';
import { teamExamsResultRoute } from './exam/examConduct/examsResult.route';

export const teamExamConductContainerRoute: RouteConfig = {
  path: 'examsConduct',
  component: RouterView,
  meta: { breadcrumb: {} },
  children: [teamExamsConductRoute, teamExamsResultRoute]
};
